import { withTheme } from '@emotion/react'
import styled from '@emotion/styled';

/**
 * BasicTextBlock
 * @props   {string} header  Header text
 * @props   {string} copy  Copy text
 * @props   {string} textColor  Text color
 * @props   {string} textAlign  Left or right positioning
 * @props   {string} overrideCenter  Override for positioning
 */

const BlockContainer = styled.div`
  align-items: center;
  color: ${props => props.theme.colors[props.textColor]};
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  justify-content: center;
  max-width: ${props => props.theme.breakpoints.lg};
  padding-top: ${props => props.paddingValue};
  text-align: ${props => props.textAlign};
  max-width: 700px;
  
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    text-align: ${props => props.textAlign};
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    text-align: ${props => (props.textAlign === "left" || props.overrideCenter) ? "left" : "center"};
  }
`;

const StyledH2 = styled.h2`
  color: ${props => props.theme.colors[props.headerColor]};
  display: flex;
  flex-basis: 100%;
  font-family: ${props => props.theme.fonts.primary};
  font-size: ${props => props.headerFontSize};
  font-weight: bold;
  line-height: ${props => props.theme.lineHeights.lg};

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    align-self: ${props => (props.textAlign === "left" || !!props.overrideCenter) ? "flex-start" : "center"};
  }
`;

const TitleSpan = styled.span`
  &:nth-of-type(2) {
    font-weight: ${props => props.emphasis ? "normal" : "bold"};
  }
`;

const StyledP = styled.p` 
  display: flex;
  flex-basis: 100%;
  font-family: ${props => props.theme.fonts.secondary};
  font-size: ${props => props.theme.fontSizes.sm};
  line-height: ${props => props.theme.lineHeights.std};
  padding: 24px 0;
`;

function BasicTextBlock(props) {
  const { header, copy, emphasis = false } = props.textBlockData;
  const { 
    textColor = props.theme.colors.neutral1, 
    textAlign = "center", 
    overrideCenter = false, 
    headerColor = props.theme.colors.neutral1,
    headerFontSize = props.theme.fontSizes.lg,
    paddingValue = props.theme.margins.std,
  } = props;

  return (
    <BlockContainer 
      className={props.className} 
      paddingValue={paddingValue} 
      overrideCenter={overrideCenter} 
      textAlign={textAlign} 
      textColor={textColor}>
      {header.length > 0 && <StyledH2 
        overrideCenter={overrideCenter} 
        headerColor={headerColor}
        headerFontSize={headerFontSize}
        textAlign={textAlign}>
          {header.map(text => <TitleSpan key={text.substring(0,10)} emphasis={emphasis}>{text}</TitleSpan>)}
      </StyledH2>}
      {copy.length > 0 && <StyledP key={copy[0].substring(0,10)}>{copy}</StyledP>}
    </BlockContainer>
  )
}

export default withTheme(BasicTextBlock);